// Rotas públicas do App.tsx (sem ProtectedRoute). Nelas a sessão salva no
// localStorage não deve ser validada nem forçar redirect para /login: quem
// chega por um link de SSO, convite, ativação ou redefinição de senha pode ter
// uma sessão antiga e expirada, e o redirect derrubava o fluxo no meio.
const PUBLIC_PATHS = ['/login', '/signup', '/forgot-password', '/auth/callback'];
const PUBLIC_PREFIXES = ['/acesso/'];

export function isPublicPath(pathname: string | undefined): boolean {
  if (!pathname) return false;
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return (
    PUBLIC_PATHS.includes(path) ||
    PUBLIC_PREFIXES.some((prefix) => path.startsWith(prefix))
  );
}
